// AssignmentView.jsx
// PART 1 / 2

import React, {
  useEffect,
  useState,
  useMemo
} from "react";

import api from "../../api/api";

import Swal from "sweetalert2";

import {
  Layout,
  Card,
  Avatar,
  Typography,
  Button,
  Input,
  Select,
  Space,
  Row,
  Col,
  Divider,
  Tag,
  Modal,
  Form,
  DatePicker,
  Empty,
  Spin,
  Badge,
  Tooltip,
} from "antd";


import {
  LikeOutlined,
  LikeFilled,
  MessageOutlined,
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  UserOutlined,
  BookOutlined,
  CalendarOutlined,
  TeamOutlined,
} from "@ant-design/icons";


import dayjs from "dayjs";

import defaultAvatar from "./maleee.jpg";



const {
  Title,
  Text,
  Paragraph
} = Typography;


const { TextArea } = Input;





const AssignmentView = () => {



  // =========================
  // STATES
  // =========================


  const [assignments,setAssignments] = useState([]);

  const [subjects,setSubjects] = useState([]);

  const [filterSubject,setFilterSubject] = useState("");

  const [loading,setLoading] = useState(true);



  const [teacher,setTeacher] = useState(null);



  // COMMENTS

  const [
    expandedComments,
    setExpandedComments
  ] = useState({});


  const [
    commentsData,
    setCommentsData
  ] = useState({});


  const [
    commentInput,
    setCommentInput
  ] = useState({});


  const [
    replyInput,
    setReplyInput
  ] = useState({});


  const [
    activeReplyBox,
    setActiveReplyBox
  ] = useState(null);





  // EDIT MODAL


  const [
    editModalOpen,
    setEditModalOpen
  ] = useState(false);



  const [
    editAssignment,
    setEditAssignment
  ] = useState(null);



  const [
    editForm
  ] = Form.useForm();



  const [
    gradeClasses,
    setGradeClasses
  ] = useState([]);



  const [
    allSubjects,
    setAllSubjects
  ] = useState([]);








  // =========================
  // SUCCESS / ERROR
  // =========================


  const success = (title,text)=>{

    Swal.fire({

      icon:"success",

      title,

      text,

      timer:1500,

      showConfirmButton:false

    });

  };



  const error = (title,text)=>{

    Swal.fire({

      icon:"error",

      title,

      text

    });

  };









  // =========================
  // FETCH TEACHER PROFILE
  // =========================


  const fetchTeacherProfile = async()=>{


    try{


      const res = await api.get(
        "/api/users/profile/"
      );


      setTeacher(res.data);



    }catch(err){


      console.log(
        "Teacher profile error",
        err
      );


    }


  };









  // =========================
  // FETCH ASSIGNMENTS
  // =========================


  const fetchAssignments = async()=>{


    try{


      setLoading(true);


      const res = await api.get(
        "/api/assignments/"
      );



      setAssignments(
        res.data || []
      );



      const subjectList = [

        ...new Set(

          res.data.map(

            item=>item.subject_name

          )

        )

      ];



      setSubjects(subjectList);



    }catch(err){


      error(
        "Error",
        "Unable to load assignments"
      );


    }finally{


      setLoading(false);


    }


  };









  // =========================
  // FETCH TEACHER SUBJECT DATA
  // =========================


  const fetchTeacherSubjects = async()=>{


    try{


      const res = await api.get(
        "/api/users/teacher-subjects/"
      );


      setGradeClasses(
        res.data.grade_classes || []
      );


      setAllSubjects(
        res.data.subjects || []
      );



    }catch(err){


      console.log(err);


    }


  };










  useEffect(()=>{


    fetchAssignments();

    fetchTeacherProfile();

    fetchTeacherSubjects();


  },[]);











  // =========================
  // FILTER ASSIGNMENTS
  // =========================


  const filteredAssignments = useMemo(()=>{


    if(!filterSubject)

      return assignments;



    return assignments.filter(

      item=>

      item.subject_name === filterSubject

    );


  },[assignments,filterSubject]);









  // =========================
  // LIKE ASSIGNMENT
  // =========================


  const handleLike = async(id)=>{


    try{


      await api.post(

        `/api/assignments/${id}/like/`

      );


      fetchAssignments();



    }catch(err){


      error(
        "Error",
        "Like failed"
      );


    }


  };









  // =========================
  // DELETE ASSIGNMENT
  // =========================


  const handleDelete = async(id)=>{


    const result = await Swal.fire({

      title:"Delete Assignment?",

      text:"This cannot be reversed",

      icon:"warning",

      showCancelButton:true,

      confirmButtonText:"Delete"

    });



    if(!result.isConfirmed)

      return;




    try{


      await api.delete(

        `/api/assignments/${id}/`

      );



      setAssignments(prev=>

        prev.filter(

          item=>item.id!==id

        )

      );



      success(
        "Deleted",
        "Assignment removed"
      );



    }catch(err){


      error(
        "Error",
        "Delete failed"
      );


    }


  };









  // =========================
  // OPEN EDIT MODAL
  // =========================


  const openEdit = (assignment)=>{


    setEditAssignment(
      assignment
    );


    editForm.setFieldsValue({

      title:
      assignment.title,


      due_date:
      dayjs(
        assignment.due_date
      ),


      description:
      assignment.description,


      grade_class:
      assignment.grade_class,


      subject:
      assignment.subject,


    });


    setEditModalOpen(true);


  };









  const closeEdit = ()=>{


    setEditModalOpen(false);


    setEditAssignment(null);


    editForm.resetFields();


  };









  // =========================
  // COMMENT FUNCTIONS
  // =========================


  const toggleComments = async(id)=>{


    const open =
      expandedComments[id];



    setExpandedComments(prev=>({

      ...prev,

      [id]:!open

    }));



    if(!open){


      try{


        const res = await api.get(

          `/api/assignments/${id}/comments/`

        );



        setCommentsData(prev=>({

          ...prev,

          [id]:res.data

        }));



      }catch(err){


        error(
          "Error",
          "Unable to load comments"
        );


      }


    }


  };









  const postComment = async(id)=>{


    const content =
    commentInput[id];



    if(!content?.trim())

      return;



    try{


      await api.post(

        `/api/assignments/${id}/comments/`,

        {

          content:content.trim()

        }

      );



      setCommentInput(prev=>({

        ...prev,

        [id]:""

      }));



      toggleComments(id);


      toggleComments(id);



    }catch(err){


      error(
        "Error",
        "Comment failed"
      );


    }


  };









  const postReply = async(
    assignmentId,
    commentId
  )=>{


    const content =
    replyInput[commentId];



    if(!content?.trim())

      return;



    try{


      await api.post(

        `/api/assignments/${assignmentId}/comments/${commentId}/reply/`,

        {

          content:
          content.trim()

        }

      );



      setReplyInput(prev=>({

        ...prev,

        [commentId]:""

      }));



      const res =
      await api.get(

        `/api/assignments/${assignmentId}/comments/`

      );


      setCommentsData(prev=>({

        ...prev,

        [assignmentId]:res.data

      }));


      setActiveReplyBox(null);



    }catch(err){


      error(
        "Error",
        "Reply failed"
      );


    }


  };





// PART 2 / 2
// Continue inside return section of AssignmentView


return (

<Layout
style={{
  minHeight:"100vh",
  background: "transparent",
  padding:"12px"
}}
>

<div
style={{
  width:"100%",
  maxWidth:"1800px",
  margin:"0 auto",
  padding:"0 4px"
}}
>



{/* ===========================
    TEACHER PROFILE HEADER
=========================== */}


<Card

style={{

  borderRadius:20,

background:
  "linear-gradient(135deg,#000000,#F57C00)",

  marginBottom:20

}}

>


<Row

align="middle"

gutter={[20,20]}

>


<Col>

<Avatar

size={90}

src={
teacher?.profile_image ||
defaultAvatar
}

icon={<UserOutlined/>}

style={{

border:"4px solid #ff8000"

}}

/>

</Col>



<Col flex="auto">


<Title

level={3}

style={{

color:"#fff",

margin:0

}}

>

{teacher?.username ||
"Teacher"}

</Title>


<Text

style={{

color:"#d1d5db"

}}

>

Teacher Assignment Community

</Text>



</Col>



<Col>


<Tag

color="red"

icon={<BookOutlined/>}

>

Assignments

</Tag>


</Col>



</Row>


</Card>








{/* ===========================
    FILTER BAR
=========================== */}


<Card

style={{

borderRadius:18,

marginBottom:20

}}

>


<Row
gutter={[15,15]}
justify="center"
>

<Col
xs={24}
sm={20}
md={12}
>

<Select
style={{
width:"100%"
}}
size="large"
placeholder="Filter Subject"
allowClear
value={filterSubject}
onChange={setFilterSubject}
options={subjects.map(s=>({
label:s,
value:s
}))}
/>

</Col>

</Row>


</Card>









{/* ===========================
    ASSIGNMENT SOCIAL FEED
=========================== */}



{

loading

?

<div

style={{

textAlign:"center",

padding:50

}}

>

<Spin size="large"/>

</div>


:


filteredAssignments.length===0


?


<Empty

description="No assignments available"

/>


:


<Row
gutter={[30,30]}
justify="center"
align="stretch"
style={{
width:"100%",
margin:"0 auto",
}}
>


{

filteredAssignments.map((assignment)=>(


<Col
xs={24}
sm={24}
md={20}
lg={12}
xl={10}
key={assignment.id}
>



<Card
hoverable
style={{
borderRadius:24,
overflow:"hidden",
borderTop:"5px solid #6b0f1a",
height:"100%",
width:"100%",
}}
bodyStyle={{
padding:"28px"
}}
>





{/* POST HEADER */}

<Row

align="middle"

gutter={12}

>


<Col>


<Avatar

src={
assignment.teacher_image ||
defaultAvatar
}

icon={<UserOutlined/>}

/>


</Col>



<Col flex="auto">


<Text strong>

{
assignment.teacher_name ||
"Teacher"
}

</Text>


<br/>


<Text type="secondary">

Posted an assignment

</Text>


</Col>



</Row>





<Divider/>







{/* ASSIGNMENT BODY */}



<Title

level={4}

style={{

marginBottom:5

}}

>

{assignment.title}

</Title>




<Space wrap>


<Tag

icon={<BookOutlined/>}

color="purple"

>

{assignment.subject_name}

</Tag>



<Tag

icon={<TeamOutlined/>}

color="blue"

>

{assignment.grade_class_name}

</Tag>



<Tag

icon={<CalendarOutlined/>}

color="red"

>

{assignment.due_date}

</Tag>


</Space>





<Paragraph

style={{

marginTop:15,

minHeight:60

}}

>

{assignment.description}

</Paragraph>









{/* ACTION BAR */}



<Row

justify="space-between"

align="middle"

>


<Button

type="text"

icon={

assignment.liked

?

<LikeFilled/>

:

<LikeOutlined/>

}

onClick={()=>handleLike(assignment.id)}

>

{assignment.likes_count || 0}

</Button>






<Button

type="text"

icon={<MessageOutlined/>}

onClick={()=>
toggleComments(assignment.id)
}

>

Comments

{
assignment.comments_count || 0
}

</Button>



{

assignment.can_edit &&


<Space>


<Tooltip title="Edit">

<Button

icon={<EditOutlined/>}

onClick={()=>
openEdit(assignment)
}

/>

</Tooltip>





<Tooltip title="Delete">

<Button

danger

icon={<DeleteOutlined/>}

onClick={()=>
handleDelete(assignment.id)
}

/>

</Tooltip>



</Space>


}



</Row>










{/* ======================
COMMENTS
====================== */}



{

expandedComments[assignment.id] &&



<div

style={{

marginTop:20,

background:"#f8fafc",

padding:15,

borderRadius:15

}}

>


<Input.TextArea

rows={2}

placeholder="Write a comment..."

value={
commentInput[assignment.id] || ""
}

onChange={e=>

setCommentInput(prev=>({

...prev,

[assignment.id]:
e.target.value

}))

}

/>



<Button

type="primary"

style={{

marginTop:10,

background:"#6b0f1a",

borderColor:"#6b0f1a"

}}

onClick={()=>postComment(assignment.id)}

>

Comment

</Button>






<div

style={{

maxHeight:250,

overflowY:"auto",

marginTop:15

}}

>



{

commentsData[assignment.id]?.map(comment=>(


<Card

size="small"

key={comment.id}

style={{

marginBottom:10,

borderRadius:12

}}

>



<Space>


<Avatar

src={
comment.user?.profile_image ||
defaultAvatar
}

/>


<div>


<Text strong>

{comment.username}

</Text>


<br/>


<Text>

{comment.content}

</Text>


<br/>


<Button

type="link"

size="small"

onClick={()=>setActiveReplyBox(

activeReplyBox===comment.id

?

null

:

comment.id

)}

>

Reply

</Button>



</div>



</Space>





{


activeReplyBox===comment.id &&


<div>


<Input

placeholder="Reply..."

value={
replyInput[comment.id] || ""
}

onChange={e=>

setReplyInput(prev=>({

...prev,

[comment.id]:
e.target.value

}))

}

/>



<Button

size="small"

type="primary"

style={{

marginTop:5

}}

onClick={()=>postReply(

assignment.id,

comment.id

)}

>

Send

</Button>


</div>


}








{/* NESTED REPLIES */}



{

comment.replies?.map(reply=>(


<div

key={reply.id}

style={{

marginLeft:35,

marginTop:10

}}

>


<Space>


<Avatar

size="small"

src={

reply.user?.profile_image ||

defaultAvatar

}

/>


<Text>

<b>{reply.username}</b>

<br/>

{reply.content}

</Text>


</Space>



</div>


))

}





</Card>


))


}



</div>



</div>


}




</Card>



</Col>


))


}


</Row>


}









{/* ===========================
EDIT MODAL
=========================== */}



<Modal

open={editModalOpen}

title="Edit Assignment"

onCancel={closeEdit}

footer={null}

>


<Form

form={editForm}

layout="vertical"

>


<Form.Item

label="Title"

name="title"

>

<Input/>

</Form.Item>



<Form.Item

label="Due Date"

name="due_date"

>

<DatePicker

style={{

width:"100%"

}}

/>

</Form.Item>




<Form.Item

label="Description"

name="description"

>

<TextArea

rows={5}

/>

</Form.Item>





<Button

block

type="primary"

style={{

background:"#6b0f1a",

borderColor:"#6b0f1a"

}}

>

Update Assignment

</Button>



</Form>



</Modal>








</div>


</Layout>


);


};

export default AssignmentView;

